import { hasPermission } from '@/composables/RequiredPermissions'
import { isRouteLoading } from '@/composables/routeLoading'
import { PERMISSIONS, UserPermission } from '@/models/enums/permissions'
import routes from '@/routes'
import type { App } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

const permissionDeniedRedirects: Partial<Record<UserPermission, string>> = {
  [PERMISSIONS.PAGES.DASHBOARD_VIEW]: '/medidores',
  [PERMISSIONS.VEE.GROUPS_VIEW]: '/sem-permissao',
  [PERMISSIONS.VEE.GROUPS_MANAGE]: '/sem-permissao',
  [PERMISSIONS.VEE.GROUPS_ADMINISTER]: '/sem-permissao',
  [PERMISSIONS.VEE.RULES_VIEW]: '/sem-permissao',
  [PERMISSIONS.VEE.RULES_MANAGE]: '/sem-permissao',
  [PERMISSIONS.VEE.SERVICE_REQUESTS_VIEW]: '/sem-permissao',
  [PERMISSIONS.VEE.SERVICE_REQUESTS_MANAGE]: '/sem-permissao',
  [PERMISSIONS.VEE.MANUAL_OVERRIDE_EDIT]: '/sem-permissao',
}

function isUserLoggedIn() {
  return (
    !!localStorage.getItem('accessToken') &&
    localStorage.getItem('accessToken') !== null &&
    localStorage.getItem('accessToken') !== 'null' &&
    localStorage.getItem('user') !== null &&
    localStorage.getItem('user') !== 'null'
  )
}

router.beforeEach((to, from, next) => {
  const requiredPermission = to.meta?.requiredPermission as UserPermission | undefined
  if (requiredPermission && !hasPermission(requiredPermission)) {
    const redirect = permissionDeniedRedirects[requiredPermission]

    if (!isUserLoggedIn()) {
      return next({ name: 'Login' })
    }

    if (!redirect) {
      return next({ name: 'NotFound' })
    }

    return next(redirect)
  }

  if (to.name === 'NotFoundPublic') {
    if (!isUserLoggedIn()) {
      return next({ name: 'Login' })
    }
    return next({ name: 'NotFound' })
  }

  if (to.name === 'NotFound' && !isUserLoggedIn()) {
    return next({ name: 'Login' })
  }

  return next()
})

router.beforeEach(() => {
  isRouteLoading.value = true
})

router.afterEach(() => {
  isRouteLoading.value = false
})

router.onError(() => {
  isRouteLoading.value = false
})

export function registerRoutes(app: App) {
  app.use(router)
}
